import React from 'react';

import MonitorPingMessageBadge from 'shared/ui/Status/MonitorPingMessageBadge';
import CopyButton from 'shared/ui/IconButton/CopyButton/CopyButton';
import IMonitorLog from 'features/http/model/HttpMonitor/IHttpMonitorResult';
import {getFormattedDate} from 'shared/lib/datetime';
import {nv} from 'shared/lib/format/string';
import {isTranslate} from 'shared/lib/lang';

import {t} from '@lingui/core/macro';

import IconLogsResult from './IconLogsResult';

import styles from './HttpMonitorLogs.module.scss';

interface IHttpMonitorLogRowProps {
    item: IMonitorLog,
    tzString?: string|null,
}

const HttpMonitorLogRow: React.FC<IHttpMonitorLogRowProps> = ({item, tzString}) => {
    return (
        <tr>
            <td className={styles.blockResult}>
                <IconLogsResult code={item.code} />
                <MonitorPingMessageBadge code={item.code} message={item.message} />
            </td>
            <td>
                {getFormattedDate(item.checked_at,
                    {format: !isTranslate() ? 'DD.MM.YYYY, в HH:mm' : 'YYYY-MM-DD, in HH:mm', tzString})}
            </td>
            <td>{item.code}</td>
            <td>{nv(item.request_time)}</td>
            <td>{item.location?.country}, {item.location?.city}, {item.location?.name}</td>
            <td>
                <div className={styles.ipCell}>
                    {item.location?.ip}
                    <CopyButton
                        value={item.location.ip}
                        ariaLabel={t`Копировать IP`}
                        tooltipClassName={styles.tooltip}
                        buttonClassName={styles.copyButton}
                    />
                </div>
            </td>
        </tr>
    );
};

export default HttpMonitorLogRow;